import { FC } from 'react';
import { sanitizeHtml } from '@new/common/lib/sanitize';
import { usePathContext } from '@new/common/hooks/usePathContext';
import { Video } from '@new/common/ui/Video/Video';
import { LessonObjectives } from '@new/features/courses/components/LessonObjectives/LessonObjectives';
import { useGetCourseQuery } from '@teachur/http-client';

interface LessonDetailTabProps {
  lesson: Lesson;
}

export const LessonDetailTab: FC<LessonDetailTabProps> = ({ lesson }) => {
  const { courseId } = usePathContext();
  const { data: course } = useGetCourseQuery(courseId ?? 0);
  const isExamPassed = course?.quizCompleted || course?.courseExam?.passed;
  return (
    <div className="flex flex-col gap-6">
      {/* Video Section */}
      {lesson.introVideo && <Video videoUrl={lesson.introVideo} />}

      {/* Description Section */}
      <div className="flex flex-col gap-4">
        <h3 className="[font-size:var(--fs-h6)]! text-(--neutral-black-NB1000)! font-bold m-0!">
          Description
        </h3>
        {lesson.longDescription ? (
          <div
            className="[font-size:var(--fs-p4)]! text-(--neutral-black-NB900)! leading-[150%]"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(lesson.longDescription) }}
          />
        ) : (
          <p className="[font-size:var(--fs-p4)]! text-(--neutral-black-NB900)! leading-[150%]">
            {lesson.shortDescription}
          </p>
        )}
      </div>
      <LessonObjectives
        lessonId={lesson.id}
        courseId={courseId}
        courseStatus={course?.status ?? 'notStarted'}
        isPaused={course?.isPaused ?? false}
        isExamPassed={isExamPassed}
      />
    </div>
  );
};
